import { Api, queryClient, queryKeys } from "@/infrastructure";
import { useMutation, UseMutationResult } from "react-query";
import snakecaseKeys from "snakecase-keys";

export const useCreateDirectScheduleInquiryMutation = (
  token: string
): UseMutationResult => {
  return useMutation(
    ({
      category,
      message,
      name,
      contactDetails,
      blanketContractOrderIds,
    }: {
      category: string;
      message: string;
      name: string;
      contactDetails: string;
      blanketContractOrderIds: number[];
    }) => {
      return Api.post({
        path: `direct_schedule_adjustments/${token}/inquiries`,
        data: {
          ...snakecaseKeys({
            message,
            category,
            name,
            contactDetails,
            blanketContractOrderIds,
          }),
        },
      });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([
          queryKeys.directScheduleAdjustment,
          token,
        ]);
      },
    }
  );
};
